/**
 * Adapptio library to help creating components.
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

const urlProtocolRegExp = /^([a-zA-Z]+:)?\/\//;

/**
 * Checks whether or not is link external
 *
 * @param to Link (relative / absolute path or URL)
 */
export function isLinkExternal(to: string): boolean {
	return urlProtocolRegExp.test(to);
}
